const israelFormatter = new Intl.DateTimeFormat('en-IL', {
  timeZone: 'Asia/Jerusalem',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  hour12: false,
})

const israelDayFormatter = new Intl.DateTimeFormat('en-IL', {
  timeZone: 'Asia/Jerusalem',
  weekday: 'long',
})

const israelDateFormatter = new Intl.DateTimeFormat('en-IL', {
  timeZone: 'Asia/Jerusalem',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
})

const israelMonthFormatter = new Intl.DateTimeFormat('en-IL', {
  timeZone: 'Asia/Jerusalem',
  month: 'numeric',
})

export function getIsraelTime(date: Date = new Date()): { hour: number; minute: number; second: number } {
  const parts = israelFormatter.formatToParts(date)
  const hour = parseInt(parts.find(p => p.type === 'hour')!.value)
  const minute = parseInt(parts.find(p => p.type === 'minute')!.value)
  const second = parseInt(parts.find(p => p.type === 'second')!.value)
  return { hour, minute, second }
}

export function getIsraelDay(date: Date = new Date()): string {
  return israelDayFormatter.format(date)
}

export function getIsraelMonth(date: Date = new Date()): number {
  return parseInt(israelMonthFormatter.format(date))
}

export function getIsraelDateStr(date: Date = new Date()): string {
  return israelDateFormatter.format(date)
}

export function isWeekend(date: Date = new Date()): boolean {
  const day = getIsraelDay(date)
  const { hour } = getIsraelTime(date)

  // Off-peak weekend: Thursday 22:00 → Sunday 17:00 (67 consecutive hours)
  if (day === 'Friday' || day === 'Saturday') return true
  if (day === 'Thursday' && hour >= 22) return true
  if (day === 'Sunday' && hour < 17) return true

  return false
}
